<div class="vc-modal__innerContainer i18nChoices__modalContent">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <div
    *ngIf="data && data.product && data.product.inStock"
    class="vc-modal__title"
    i18n="@@PRODUCT.DETAILS.LOCALISATION.KNOW_MORE_MODAL.TITLE_IN_STOCK"
  >
    Item's location
  </div>
  <div
    *ngIf="data && data.product && !data.product.inStock"
    class="vc-modal__title"
    i18n="@@PRODUCT.DETAILS.LOCALISATION.KNOW_MORE_MODAL.TITLE_OUT_STOCK"
  >
    Item's location
  </div>
  <div class="vc-modal__content" i18n="@@PRODUCT.DETAILS.LOCALISATION.KNOW_MORE_MODAL.CONTENT">
    <p>
      Once purchased: <br />
      -If the item is in the seller's hands, it will rst be sent by the seller to Vestiaire Collective. Once it passes
      authenticity and quality control, the item will then be sent to you by Vestiaire Collective <br />
      - If the item is at Vestiaire Collective, that means it has already been authenticated by our team of experts.
      <br />> - If the article is already at Vestiaire Collective, it has already been received and checked by our team
      of experts.
    </p>
  </div>
</div>
